import {Action, createFeatureSelector, createReducer, createSelector, on} from '@ngrx/store';
import * as fromActions from './cms-actions';
import {AppStateNameEnum} from '@core/enums/app-state-name.enum';
import {InformationUnitModel} from '@core/modules/rest/informationunit/response/information-unit.model';
import {crateNewUnit, replaceUnitInfoInOutline} from '../../display-consent/helpers/helper-outline';
import {OutlineUnitBasicModel} from '@core/modules/rest/consent/response/outline-unit-basic.model';

export const REDUCER_NAME = AppStateNameEnum.feature_cms;

export interface State {
    outline: OutlineUnitBasicModel[];
    unit: InformationUnitModel;
    loading: boolean;
}

const initialState: State = {
    outline: null,
    unit: null,
    loading: false
};

const stateSelector = createFeatureSelector<State>(REDUCER_NAME);

export const outlineSelector = createSelector(stateSelector, (state: State) => state.outline);
export const informationUnitSelector = createSelector(stateSelector, (state: State) => state.unit);
export const loadingSelector = createSelector(stateSelector, (state: State) => state.loading);

const innerReducer = createReducer(
    initialState,
    on(fromActions.GetInformationUnit, ((state: State): State => {
        return ({
            ...state,
            loading: true
        });
    })),
    on(fromActions.GetInformationUnitSuccess, ((state: State, {unit}): State => ({
        ...state,
        unit,
        loading: false
    }))),
    on(fromActions.SaveInformationUnit, ((state: State): State => {
        return ({
            ...state,
            loading: true
        });
    })),
    on(fromActions.SaveInformationUnitSuccess, ((state: State, {unit}): State => ({
        ...state,
        unit,
        loading: false
    }))),
    on(fromActions.ResetEditorInfo, (() => {
        return initialState;
    })),
    on(fromActions.ResetInformationUnitInfo, ((state: State): State => {
        return {
            ...state,
            unit: null
        };
    })),
    on(fromActions.GetCMSOutline, ((state: State): State => {
        return {
            ...state,
            loading: true
        };
    })),
    on(fromActions.GetCMSOutlineSuccess, ((state: State, {outline}): State => ({
        ...state,
        outline,
        loading: false
    }))),
    on(fromActions.CreateNewUnitInOutline, ((state: State, {unit, indicationId, language}): State => {
        const newUnit: OutlineUnitBasicModel = crateNewUnit(unit, indicationId, language);
        return {
            ...state,
            outline: [...state.outline, newUnit]
        };
    })),
    on(fromActions.UpdateUnitInOutline, ((state: State, {unit, language}): State => ({
        ...state,
        outline: replaceUnitInfoInOutline(state.outline, unit, language)
    }))),
    on(fromActions.MoveUnitLevelDown, ((state: State): State => ({
        ...state
    }))),
    on(fromActions.MoveUnitLevelDownSuccess, ((state: State, {units}): State => ({
        ...state,
        outline: units
    }))),
    on(fromActions.MoveUnitLevelUp, ((state: State): State => ({
        ...state
    }))),
    on(fromActions.MoveUnitLevelUpSuccess, ((state: State, {units}): State => ({
        ...state,
        outline: units
    }))),
    on(fromActions.ReorderUnits, ((state: State): State => ({
        ...state
    }))),
    on(fromActions.ReorderUnitsSuccess, ((state: State, {units}): State => ({
        ...state,
        outline: units
    }))),
    on(fromActions.DeleteUnit, ((state: State): State => ({
        ...state
    }))),
    on(fromActions.DeleteUnitSuccess, ((state: State, {units}): State => ({
        ...state,
        outline: units
    })))
);

export function cmsReducer(state: State | undefined, action: Action): State {
    return innerReducer(state, action);
}

